import { gql } from '@apollo/client'

export const RESOURCE_QUERY = gql`
query ResourceQuery($id: String!){
	nodeById(id: $id) {

			... on NodeResource {
				uuid
				fieldResourceTags{
                    entity{
                       entityLabel
                       }
                }  
				entityChanged
				entityId
				entityLabel
				entityType
				fieldResourceDescription
				isLikedByCurrentUser
				fieldResourceImportedFromSap
				fieldResourceFromDate
				fieldResourceReleaseDate
				fieldResourceOfflinePeriod {
                    targetId
                }
				fieldResourceFilesByFormat {
					entity {
						... on Media {
							uuid
							entityChanged
							entityLabel
							entityType
							entityBundle
							entityId
						}
						... on MediaMediaFile {
							fieldMediaFileLanguage {
								value
							}
							fieldMediaFile {
								entity {
									... on File {
									    uuid
										entityChanged
										url
										filesize
										filemime
										filename
									}
								}
							}
						}
						... on MediaSapFile {
						    uuid
							entityChanged
							entityId
							fieldSapFromDate
							fieldSapReleaseDate
							fieldSapFileFileSize
							fieldSapFileFileName
							fieldSapFileDocumentVersion
							fieldSapFileMime
							fieldSapFileLanguage {
								value
							}
							fieldSapFileFileExtension {
								entity {
									... on TaxonomyTermFileExtension {
										fieldFileExtensionValue
									}
								}
							}
						}
						... on MediaMasterControl {
               uuid
               entityChanged
               entityId
               fieldMasterControlId
               fieldMasterControlCategory
               fieldMasterControlDescription
               fieldMasterControlTitle
               fieldMasterControlRevision
               fieldMasterControlMime
               fieldMasterControlSize
               fieldMasterControlExtension {
                entity {
                  ... on TaxonomyTermFileExtension {
                    fieldFileExtensionValue
                  }
                }
               }
            }
            ... on MediaMasterControlAttachment {
               uuid
               entityChanged
               entityId
               fieldMcAttachmentId
               fieldMcAttachmentName
               fieldMcAttachmentDescription
               fieldMcAttachmentMime
               fieldMcAttachmentSize
               fieldMcAttachmentExtension {
                entity {
                  ... on TaxonomyTermFileExtension {
                    fieldFileExtensionValue
                  }
                }
               }
            }
            ... on MediaBokeccVideo {
                fieldBokeccIframe
            }
					}
				}
			}
		}
	
}
`
;
